import React from 'react';
import { getAvatarColor, getInitials, isValidImageUrl } from '../../util/getAvatarColor';
import DefaultProfile from '../../assets/images/profile.png';

export interface EmployeeAvatarProps {
  name: string;
  avatar?: string | null | undefined;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  showBorder?: boolean;
  borderColor?: string;
  className?: string;
}

const sizeClasses = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
};

const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({
  name,
  avatar,
  size = 'md',
  showBorder = false,
  borderColor,
  className = '',
}) => {
  const hasValidImage = isValidImageUrl(avatar);
  const backgroundColor = getAvatarColor(name);
  const initials = getInitials(name);

  const borderStyle = showBorder
    ? { border: `2px solid ${borderColor || backgroundColor}` }
    : {};

  if (hasValidImage) {
    return (
      <img
        src={avatar || DefaultProfile}
        alt={name}
        className={`${sizeClasses[size]} rounded-full object-cover ${className}`}
        style={borderStyle}
        onError={(e) => {
          // Fallback to initials if image fails to load
          (e.target as HTMLImageElement).src = DefaultProfile;
        }}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center font-semibold text-white flex-shrink-0 ${className}`}
      style={{ backgroundColor, ...borderStyle }}
    >
      {initials}
    </div>
  );
};

export default EmployeeAvatar;
